export default {"src":"/_next/static/media/0x5183e1b1091804bc2602586919e6880ac1cf2896.a3322cf8.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};